import { Box, Text, Icon, BoxProps, IconProps } from '@nimbus-ds/components';
import { Link } from 'react-router-dom';
import { IconBox } from 'commons/components';
import Skeleton from './Skeleton';

export const BOX_PROPS_PENDING_ORDERS_CARD: BoxProps = {
  boxShadow: '1',
  backgroundColor: 'neutral-background',
  borderColor: 'neutral-surfaceHighlight',
  borderStyle: 'solid',
  borderRadius: 'base',
  borderWidth: '1',
  padding: '2',
  gap: '2',
  flex: '1',
  width: '100%',
  display: 'flex',
};

interface PendingOrdersCardProps {
  title?: string;
  subtitle: string;
  to: string;
  icon: IconProps['source'];
  skeleton?: boolean;
  onClick?: () => void;
  hideIcon?: boolean;
  shouldGoToOldAdmin: boolean;
}

function PendingOrdersCard({
  title,
  subtitle,
  icon,
  skeleton,
  to,
  onClick,
  hideIcon,
  shouldGoToOldAdmin,
}: PendingOrdersCardProps) {
  if (skeleton) return <Skeleton />;
  return (
    <Box {...BOX_PROPS_PENDING_ORDERS_CARD}>
      <Box
        pointerEvents={hideIcon ? 'none' : undefined}
        as={shouldGoToOldAdmin ? 'a' : Link}
        to={shouldGoToOldAdmin ? '' : to}
        href={shouldGoToOldAdmin ? to : undefined}
        onClick={onClick}
        cursor="pointer"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        textDecoration="none"
        flex="1"
      >
        <Box display="flex" gap="2" alignItems="center">
          <Box>
            <IconBox
              borderStyle="none"
              borderWidth="1"
              borderColor="primary-surfaceHighlight"
              backgroundColor={hideIcon ? 'neutral-surface' : 'primary-surface'}
              flex="1"
              width="24px"
            >
              <Icon
                color={hideIcon ? 'neutral-textLow' : 'primary-interactive'}
                source={icon}
              />
            </IconBox>
          </Box>
          <Box display="flex" flexDirection="column">
            {!!title && (
              <Text
                color={hideIcon ? 'neutral-textLow' : 'primary-interactive'}
                fontSize="base"
                fontWeight="regular"
              >
                {title}
              </Text>
            )}
            <Text
              color="neutral-textLow"
              fontSize="caption"
              lineHeight="caption"
            >
              {subtitle}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function PendingOrdersCardHidden() {
  return (
    <Box
      {...BOX_PROPS_PENDING_ORDERS_CARD}
      backgroundColor="transparent"
      borderColor="transparent"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        flex="1"
        minHeight="60px"
      >
        <Box display="flex" gap="2" alignItems="center">
          <Box width="40px" height="40px" />
          <Box display="flex" flexDirection="column" gap="1">
            <Box width="120px" height="16px" />
            <Box width="80px" height="14px" />
          </Box>
        </Box>
        <Box width="16px" height="16px" />
      </Box>
    </Box>
  );
}

PendingOrdersCard.Hidden = PendingOrdersCardHidden;

export default PendingOrdersCard;
